export default "__VITE_ASSET__B5oPbxfX__"